// eslint-disable-next-line
import AuthService, { sharedInstance as auth } from '@/services/AuthService'

import { projects } from '@/database'

import store from '@/store'

export default class ProjectsService
{
	private projectsListener?: () => void

	constructor(auth: AuthService)
	{
		auth.onSignedInAsObservable().subscribe(user => {
			this.handleSignedIn(user)
		})

		auth.onSignedOutAsObservable().subscribe(() => {
			store.commit('projects/clear')
			if (this.projectsListener)
			{
				this.projectsListener()
				this.projectsListener = undefined
			}
		})
	}

	private async handleSignedIn(user: UserData)
	{
		if (this.projectsListener)
		{
			this.projectsListener()
			this.projectsListener = undefined
		}

		if (!user)
		{
			return
		}

		const ref = projects.where('ownerUid', '==', user.uid).orderBy('lastUpdated', 'desc')

		store.commit('projects/clear')

		this.projectsListener = ref.onSnapshot(snap => {
			snap.docChanges().forEach(change => {
				const doc = change.doc
				const projectData = doc.data()
				projectData.uid = doc.id

				if (change.type === 'removed')
				{
					store.commit('projects/removeProject', projectData)
					return
				}

				store.commit('projects/setProjectData', projectData)
			})
		})
	}
}

const sharedInstance = new ProjectsService(auth)

export {
	sharedInstance
}
